(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-theme-video-custom"] && !Shopify.designMode) return;
  try {
    /**
   * Responsive Video Loader
   * Only loads video for the current breakpoint to optimize bandwidth
   * Uses matchMedia API for accurate breakpoint detection
   * Breakpoints: mobile (max-width: 749px), desktop (min-width: 750px)
   */
  (function() {
    const mobileMediaQuery = window.matchMedia('(max-width: 749px)');

    function getBreakpoint() {
      return mobileMediaQuery.matches ? 'mobile' : 'desktop';
    }

    function loadVideoForBreakpoint(blockId) {
      const container = document.querySelector(`.video-responsive-container[data-video-block-id="${blockId}"]`);
      if (!container) return;

      const currentBreakpoint = getBreakpoint();
      const currentLoadedBreakpoint = container.dataset.loadedBreakpoint;

      // Skip if already loaded for this breakpoint
      if (currentLoadedBreakpoint === currentBreakpoint) return;

      // Find the appropriate template
      const template = document.querySelector(`template[data-video-template="${currentBreakpoint}"][data-video-block-id="${blockId}"]`);
      if (!template) return;

      // Pause and cleanup existing video before swapping
      const existingVideo = container.querySelector('video');
      if (existingVideo) {
        existingVideo.pause();
        existingVideo.src = '';
        existingVideo.load();
      }

      // Clear container and load new video
      container.innerHTML = '';
      container.appendChild(template.content.cloneNode(true));
      container.dataset.loadedBreakpoint = currentBreakpoint;

      // Initialize the new video
      const newVideo = container.querySelector('video');
      if (newVideo) {
        newVideo.load();
      }
    }

    function initAllVideoBlocks() {
      const containers = document.querySelectorAll('.video-responsive-container[data-video-block-id]');
      containers.forEach(container => {
        const blockId = container.dataset.videoBlockId;
        loadVideoForBreakpoint(blockId);
      });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllVideoBlocks);
    } else {
      initAllVideoBlocks();
    }

    // Handle breakpoint changes using matchMedia (no debounce needed)
    mobileMediaQuery.addEventListener('change', initAllVideoBlocks);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_materials_information_accordion"] && !Shopify.designMode) return;
  try {
    (function() {
    // Map to store AbortController for each container
    const containerControllers = new WeakMap();
    let initTimeoutId = null;
    let contentObserver = null;
    
    function handleToggle(event) {
      const details = event.target;
      
      // Only process if it's a details element and it's being opened
      if (!(details instanceof HTMLDetailsElement) || !details.open) return;
      
      // Find the container
      const container = details.closest('[data-single-expand="true"]');
      if (!container) return;
      
      // Find all other details in the same container and close them
      const allDetails = container.querySelectorAll('details[open]');
      allDetails.forEach(otherDetails => {
        if (otherDetails !== details && otherDetails.open) {
          otherDetails.open = false;
        }
      });
    }

    function setupSingleExpand(container) {
      // Skip if already initialized
      if (!container || containerControllers.has(container)) return;

      // Create AbortController for this container
      const controller = new AbortController();
      containerControllers.set(container, controller);

      // Listen for toggle events on the container (event delegation)
      container.addEventListener('toggle', handleToggle, {
        capture: true,
        signal: controller.signal
      });
    }

    function init() {
      // Find all accordion containers with data-single-expand attribute
      // that haven't been initialized yet
      const containers = document.querySelectorAll('[data-single-expand="true"]:not([data-single-expand-initialized])');
      containers.forEach(container => {
        container.setAttribute('data-single-expand-initialized', 'true');
        setupSingleExpand(container);
      });
    }

    function cleanup() {
      // Clear timeout if exists
      if (initTimeoutId) {
        clearTimeout(initTimeoutId);
        initTimeoutId = null;
      }
      
      // Disconnect observer if exists
      if (contentObserver) {
        contentObserver.disconnect();
        contentObserver = null;
      }
      
      // Note: WeakMap doesn't support iteration or clear()
      // Controllers will be garbage collected when containers are removed
    }

    // Initialize immediately if DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    // Watch for dynamically loaded accordion content
    if (document.body && typeof MutationObserver !== 'undefined') {
      contentObserver = new MutationObserver(function(mutations) {
        for (let mutation of mutations) {
          for (let node of mutation.addedNodes) {
            // Check if the added node is an accordion container or contains one
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.matches && node.matches('[data-single-expand="true"]')) {
                init();
                break;
              }
              if (node.querySelector && node.querySelector('[data-single-expand="true"]')) {
                init();
                break;
              }
            }
          }
        }
      });
      
      contentObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
    
    // Cleanup on page unload
    window.addEventListener('beforeunload', cleanup, { once: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_slide-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const slideLinks = document.querySelectorAll('.slide__link');
    slideLinks.forEach((link) => {
      link.addEventListener('click', function (event) {
        if (event.target.closest('.video-custom-controls')) {
          event.preventDefault();
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_social-share"] && !Shopify.designMode) return;
  try {
    class SocialShare extends HTMLElement {
    constructor() {
      super();
      this.url = this.dataset.url;
      this.title = this.dataset.title;
      this.image = this.dataset.image;
    }

    connectedCallback() {
      // Copy link button
      const copyBtn = this.querySelector('[data-share="copy"]');
      if (copyBtn) {
        copyBtn.addEventListener('click', () => this.copyLink(copyBtn));
      }

      // Track share clicks (optional analytics)
      this.querySelectorAll('[data-share]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const platform = e.currentTarget.dataset.share;
          this.trackShare(platform);
        });
      });
    }

    async copyLink(button) {
      try {
        await navigator.clipboard.writeText(this.url);
        
        // Show success state
        const copyIcon = button.querySelector('.social-share__icon--copy');
        const copiedIcon = button.querySelector('.social-share__icon--copied');
        const label = button.querySelector('[data-copy-label]');
        
        if (copyIcon) copyIcon.hidden = true;
        if (copiedIcon) copiedIcon.hidden = false;
        if (label) label.textContent = 'Copied!';
        
        // Reset after 2 seconds
        setTimeout(() => {
          if (copyIcon) copyIcon.hidden = false;
          if (copiedIcon) copiedIcon.hidden = true;
          if (label) label.textContent = 'Copy link';
        }, 2000);
      } catch (err) {
        console.error('Copy failed:', err);
        // Fallback for older browsers
        this.fallbackCopy(this.url);
      }
    }

    fallbackCopy(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }

    trackShare(platform) {
      // Analytics tracking (customize as needed)
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'share', {
          method: platform,
          content_type: 'page',
          item_id: this.url
        });
      }
    }
  }

  if (!customElements.get('social-share')) {
    customElements.define('social-share', SocialShare);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_stitching-tea-format"] && !Shopify.designMode) return;
  try {
    class StitchingTeaFormatTabs {
    constructor() {
      this.init();
    }

    init() {
      document.querySelectorAll('.stitching-tea-format').forEach((container) => {
        const tablist = container.querySelector('[role="tablist"]');
        if (!tablist) return;

        const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
        const panels = Array.from(container.querySelectorAll('[role="tabpanel"]'));

        tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activateTab(tab, tabs, panels));
          tab.addEventListener('keydown', (e) => this.handleKeydown(e, tabs, panels));
        });
      });
    }

    activateTab(selectedTab, tabs, panels) {
      // Deactivate all tabs
      tabs.forEach((tab) => {
        tab.setAttribute('aria-selected', 'false');
        tab.setAttribute('tabindex', '-1');
        tab.classList.remove('stitching-tea-format__tab--active');
      });

      // Hide all panels
      panels.forEach((panel) => {
        panel.hidden = true;
        panel.classList.remove('stitching-tea-format__panel--active');
      });

      // Activate selected tab
      selectedTab.setAttribute('aria-selected', 'true');
      selectedTab.setAttribute('tabindex', '0');
      selectedTab.classList.add('stitching-tea-format__tab--active');

      // Show associated panel
      const panelId = selectedTab.getAttribute('aria-controls');
      const panel = document.getElementById(panelId);
      if (panel) {
        panel.hidden = false;
        panel.classList.add('stitching-tea-format__panel--active');
      }
    }

    handleKeydown(event, tabs, panels) {
      const currentIndex = tabs.indexOf(event.target);
      let newIndex;

      switch (event.key) {
        case 'ArrowLeft':
          event.preventDefault();
          newIndex = currentIndex === 0 ? tabs.length - 1 : currentIndex - 1;
          break;
        case 'ArrowRight':
          event.preventDefault();
          newIndex = currentIndex === tabs.length - 1 ? 0 : currentIndex + 1;
          break;
        case 'Home':
          event.preventDefault();
          newIndex = 0;
          break;
        case 'End':
          event.preventDefault();
          newIndex = tabs.length - 1;
          break;
        case 'Enter':
        case ' ':
          event.preventDefault();
          this.activateTab(event.target, tabs, panels);
          return;
        default:
          return;
      }

      tabs[newIndex].focus();
      this.activateTab(tabs[newIndex], tabs, panels);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new StitchingTeaFormatTabs());
  } else {
    new StitchingTeaFormatTabs();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video"] && !Shopify.designMode) return;
  try {
    /**
   * Responsive Video Loader
   * Only loads video for the current breakpoint to optimize bandwidth
   * Uses matchMedia API for accurate breakpoint detection
   * Breakpoints: mobile (max-width: 749px), desktop (min-width: 750px)
   */
  (function() {
    const mobileMediaQuery = window.matchMedia('(max-width: 749px)');

    function getBreakpoint() {
      return mobileMediaQuery.matches ? 'mobile' : 'desktop';
    }

    function loadVideoForBreakpoint(blockId) {
      const container = document.querySelector(`.video-responsive-container[data-video-block-id="${blockId}"]`);
      if (!container) return;

      const currentBreakpoint = getBreakpoint();
      const currentLoadedBreakpoint = container.dataset.loadedBreakpoint;

      // Skip if already loaded for this breakpoint
      if (currentLoadedBreakpoint === currentBreakpoint) return;

      // Find the appropriate template
      const template = document.querySelector(`template[data-video-template="${currentBreakpoint}"][data-video-block-id="${blockId}"]`);
      if (!template) return;

      // Pause and cleanup existing video before swapping
      const existingVideo = container.querySelector('video');
      if (existingVideo) {
        existingVideo.pause();
        existingVideo.src = '';
        existingVideo.load();
      }

      // Clear container and load new video
      container.innerHTML = '';
      container.appendChild(template.content.cloneNode(true));
      container.dataset.loadedBreakpoint = currentBreakpoint;

      // Initialize the new video
      const newVideo = container.querySelector('video');
      if (newVideo) {
        newVideo.load();
      }
    }

    function initAllVideoBlocks() {
      const containers = document.querySelectorAll('.video-responsive-container[data-video-block-id]');
      containers.forEach(container => {
        const blockId = container.dataset.videoBlockId;
        loadVideoForBreakpoint(blockId);
      });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllVideoBlocks);
    } else {
      initAllVideoBlocks();
    }

    // Handle breakpoint changes using matchMedia (no debounce needed)
    mobileMediaQuery.addEventListener('change', initAllVideoBlocks);
  })();
  } catch(e) { console.error(e); }
})();

})();
